<template>
  <ScrollingBox
    section-id="developer-type"
    :section-title="sectionTitle"
    :section-description="sectionDescription"
    :data="developerTypes"
    :show-right-line="true"
    :row-reverse="true"
    button-text="Learn more"
    :is-apply-button="false"
    button-redirect="how-it-works"
  />
</template>

<script>
import ScrollingBox from '../shared/ScrollingBox/ScrollingBox.vue';

export default {
  components: { ScrollingBox },
  data() {
    return {
      sectionTitle: 'What does it take to<br /> become a Proxify<br /> member?',
      sectionDescription:
        'All members must complete our vetting process, designed to<br/> assess technical expertise, communication skills, and<br/> practical know-how. The full vetting process usually takes 3-15<br/> days to complete, with approximately 4-5 hours of work.',
      developerTypes: [
        {
          illustration: '/images/home-page/developer-type/illustration1.svg',
          title: 'Technical expertise',
          description:
            'You’ve proven your real-life technical<br/> skills in a 90-minute test in your<br/> specialist area.',
        },
        {
          illustration: '/images/home-page/developer-type/illustration2.svg',
          title: 'Advanced English',
          description:
            'You’re confident working in English, and<br/> can use and understand technical terms<br/> in your specialist area.',
        },
        {
          illustration: '/images/home-page/developer-type/illustration3.svg',
          title: 'Interpersonal skills',
          description:
            'You’ve demonstrated your ability to<br/> interact effectively and harmoniously<br/> with others.',
        },
        {
          illustration: '/images/home-page/developer-type/illustration4.svg',
          title: 'Relevant experience',
          description:
            'You have 3+ years of experience<br/> in your specialist area.',
        },
        {
          illustration: '/images/home-page/developer-type/illustration5.svg',
          title: 'Organizational abilities',
          description:
            'You take pride in managing your time,<br /> energy, and physical workspace so you<br /> can work effectively.',
        },
      ],
    };
  },
};
</script>
